export class ProgressConstants {
  static importCompletedTimeout: number = 1000;
  static importFailedTimeout: number = 4000;
}
